import { render, staticRenderFns } from "./OrderDetailsBoard.vue?vue&type=template&id=eae1f8bc&scoped=true&"
import script from "./OrderDetailsBoard.vue?vue&type=script&lang=js&"
export * from "./OrderDetailsBoard.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailsBoard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderDetailsBoard.vue?vue&type=style&index=1&id=eae1f8bc&lang=scss&scoped=true&"
import style2 from "./OrderDetailsBoard.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eae1f8bc",
  null
  
)

export default component.exports